import i18n from 'i18next';
import {match, Pattern} from 'ts-pattern';

import {always, isNotNil} from 'ramda';

import {isNotNilOrZero} from 'shared/web';

export const formatTimeToResponse = (timeInSeconds: number): string => {
  const absoluteTimeInSeconds = Math.abs(timeInSeconds);
  const {days, hours, minutes, totalMinutes} = destructureTime(absoluteTimeInSeconds);

  const dayUnit = match(days)
    .with(Pattern.nullish, 0, always(null))
    .with(1, always(i18n.t('general.labels.1day').toLowerCase()))
    .with(2, 3, 4, always(i18n.t('general.labels.234days').toLowerCase()))
    .otherwise(always(i18n.t('general.labels.moreDays').toLowerCase()));

  const hourUnit = match(hours)
    .with(Pattern.nullish, 0, always(null))
    .with(1, always(i18n.t('general.labels.singleHour').toLowerCase()))
    .otherwise(always(i18n.t('general.labels.hours').toLowerCase()));

  const minuteUnit = match(minutes)
    .with(Pattern.nullish, 0, always(null))
    .with(1, always(i18n.t('general.labels.minute').toLowerCase()))
    .otherwise(always(i18n.t('general.labels.minutes').toLowerCase()));

  const formattedDays = isNotNilOrZero(days) ? `${days} ${dayUnit}` : null;
  const formattedHours = isNotNilOrZero(hours) ? `${hours} ${hourUnit}` : null;
  const formattedMinutes = isNotNilOrZero(minutes) ? `${minutes} ${minuteUnit}` : null;

  if (totalMinutes < 1) {
    return i18n.t('general.labels.lessThanAMinute');
  }

  return [formattedDays, formattedHours, formattedMinutes].filter(isNotNil).join(', ');
};

const destructureTime = (timeInSeconds: number) => {
  const totalMinutes = Math.floor(timeInSeconds / 60);
  const minutes = totalMinutes % 60;
  const totalHours = Math.floor(totalMinutes / 60);
  const hours = totalHours % 24;
  const days = Math.floor(totalHours / 24);

  return {hours, minutes, seconds: timeInSeconds, days, totalMinutes, totalHours};
};
